























































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {Env} from '@/helpers/Env'
import {ListCargoSchema} from '@/schema/resource/Cargo/ListCargoSchema'
import {CargoCollection} from '@/model/collection/CargoCollection'
import {Cargo} from '@/model/resource/Cargo'
import {CsvCargoSchema} from '@/schema/resource/Cargo/CsvCargoSchema'

@Component
export default class ListExteriorCargoView extends Mixins(MixinQueryRouter) {
  schema = new ListCargoSchema()
  collection = new CargoCollection()

  async created() {
    await this.query()
  }

  async removeItem(item: Cargo) {
    await new DialogRemove(item).confirm(() => item.removeCargo())
    await this.collection.listCargo()
  }

  async removeByCsv() {
    const file = await Helper.promptForSingleFile('.csv')

    if (file) {
      const data = await Helper.csvToNormalizedData(
        file,
        Env.CSV_BLUEPRINT.removeCargo
      )

      const ids = data.map(item => Number(item.id))

      if (ids.some(id => isNaN(id))) {
        Helper.abort('system.error.wrongFormat')
      }

      const response = await Cargo.batchRemoveCargo(ids)
      const {successQty, ignoredQty} = response

      if (ignoredQty) {
        this.$snotify.warning(
          this.$t('system.info.cargaIgnored', {ignoredQty}) as string
        )
      }

      await Helper.sleep(500)

      this.$snotify.success(
        this.$t('system.info.cargaRemoved', {successQty}) as string
      )

      await this.collection.listCargo()
    }
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargoCollection().clearFilters().addFilter(params)

    await csv.listCsvCargo()
    new CsvCargoSchema().downloadCsv(csv.all())
  }
}
